// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2qSd9","col":"CardReaderDesc_col__2p8_D","label":"CardReaderDesc_label__3-n8V"};